var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCardsinline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "No Payment Methods") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "8c2efbed-cb45-46b0-8569-76ec55eb6817",
    "data-name": "No Payment Methods"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.25,202v66.85a12.91,12.91,0,0,0,12.9,12.9H282.21a12.9,12.9,0,0,0,12.89-12.9V202ZM164,240.43a6.57,6.57,0,0,1-6.56,6.57H130.56a6.57,6.57,0,0,1-6.56-6.57V227.57a6.57,6.57,0,0,1,6.56-6.57h26.88a6.57,6.57,0,0,1,6.56,6.57Z",
    style: {
      fill: "#e0e3e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,206v62.85a8.9,8.9,0,0,1-8.89,8.9H117.15a8.91,8.91,0,0,1-8.9-8.9V206H291.1M130.56,251h26.88A10.58,10.58,0,0,0,168,240.43V227.57A10.58,10.58,0,0,0,157.44,217H130.56A10.58,10.58,0,0,0,120,227.57v12.86A10.58,10.58,0,0,0,130.56,251M295.1,202H104.25v66.85a12.91,12.91,0,0,0,12.9,12.9H282.21a12.9,12.9,0,0,0,12.89-12.9V202ZM130.56,247a6.57,6.57,0,0,1-6.56-6.57V227.57a6.57,6.57,0,0,1,6.56-6.57h26.88a6.57,6.57,0,0,1,6.56,6.57v12.86a6.57,6.57,0,0,1-6.56,6.57Z",
    style: {
      fill: "#c7cdcf"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.1,182V166.07a12.89,12.89,0,0,0-12.89-12.9H117.15a12.9,12.9,0,0,0-12.9,12.9V182Z",
    style: {
      fill: "#e0e3e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,157.17a8.9,8.9,0,0,1,8.89,8.9V178H108.25V166.07a8.91,8.91,0,0,1,8.9-8.9H282.21m0-4H117.15a12.9,12.9,0,0,0-12.9,12.9V182H295.1V166.07a12.89,12.89,0,0,0-12.89-12.9Z",
    style: {
      fill: "#c7cdcf"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.5,114H177v-5.5a1.5,1.5,0,0,0-3,0V114h-5.5a1.5,1.5,0,0,0,0,3H174v5.5a1.5,1.5,0,0,0,3,0V117h5.5a1.5,1.5,0,0,0,0-3Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,124H281v-5.5a1.5,1.5,0,0,0-3,0V124h-5.5a1.5,1.5,0,0,0,0,3H278v5.5a1.5,1.5,0,0,0,3,0V127h5.5a1.5,1.5,0,0,0,0-3Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12,92.12h-3.24V88.88a.88.88,0,0,0-1.76,0v3.24h-3.24a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0V93.88h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.12,138.12H82.88v-3.24a.88.88,0,0,0-1.76,0v3.24H77.88a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,150.12h-3.24v-3.24a.88.88,0,0,0-1.76,0v3.24h-3.24a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCardsinline);
export default __webpack_public_path__ + "static/media/no_cards.inline.3894b939.svg";
export { ForwardRef as ReactComponent };